import { createFileRoute } from "@tanstack/react-router";
import { DeptContentForm } from "@/components/dept-content/DeptContentForm";
import { DOCUMENTS } from "@/lib/deptContent";

export const Route = createFileRoute("/_app/documents/new")({
  component: () => <DeptContentForm cfg={DOCUMENTS} />,
});
